import React from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'

import { SEND_SIMULATIONS_ASYNC } from 'containers/SpearPhishingAgent/constants'

import { FillError } from 'components/lib/DesignSystem/Icons'
import Link from 'components/lib/DesignSystem/Link'

const Container = styled.div`
  width: 400px;
  padding: 0 30px;
`

const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: var(--t-typography-font-size-sm);
  font-weight: var(--t-typography-font-weight-bold);
  color: var(--psima-toast-title-color);
  margin-bottom: 8px;
`

const Description = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: var(--t-typography-font-size-xs);
  color: var(--psima-toast-description-color);
  text-align: left;
`

const ToastErrorMessage = () => {
  const dispatch = useDispatch()

  const onRetryLaunch = () => {
    dispatch(SEND_SIMULATIONS_ASYNC.initiate())
  }

  return (
    <Container>
      <Title>
        <FillError width="20px" height="20px" fill="var(--t-colors-red-900)" />
        Phishing Simulation Agent
      </Title>
      <Description>
        <div style={{ marginBottom: '8px' }}>
          Launch failed. We encountered an issue while generating your simulations.
        </div>
        <Link as="button" id="Psima_Dashboard_Error_Launched_Link" onClick={() => onRetryLaunch()}>
          Retry Launch
        </Link>{' '}
      </Description>
    </Container>
  )
}

export default ToastErrorMessage
